import * as React from "react";
import { Link } from "@grandvisionhq/common";
import { Icon } from "@grandvisionhq/icons";
import { H1 } from "@grandvisionhq/iris-ui";
import { useIntl } from "@grandvisionhq/state";
/* empty css            */
const Header = ({ backButton, title }) => {
  const { getLabel } = useIntl();
  return /* @__PURE__ */ React.createElement("header", { className: "express-checkout-header", "data-t": "express-checkout-header" }, /* @__PURE__ */ React.createElement(
    Link,
    {
      className: "express-checkout-header__button",
      href: backButton?.href,
      onClick: backButton?.onClick
    },
    /* @__PURE__ */ React.createElement(
      Icon,
      {
        name: "chevron-left",
        className: "express-checkout-header__icon",
        width: 24,
        height: 24
      }
    ),
    /* @__PURE__ */ React.createElement("span", { className: "express-checkout-header__button--label" }, getLabel("checkout.actions.previousStep"))
  ), /* @__PURE__ */ React.createElement(
    H1,
    {
      variant: "body-head",
      align: "center",
      component: "h1",
      className: "express-checkout-header__heading"
    },
    title
  ));
};
export {
  Header
};
//# sourceMappingURL=Header.js.map
